import { useMutation } from "react-query";
import { useTranslation } from "react-i18next";
import { setAcceptGroup } from "../requests/setAcceptGroup";
import { NOTIFICATIONS } from "~/constans/notifications";
import { AxiosError } from "axios";

export default function useSetAcceptGroup(
  dealerId: number,
  sentNotif: (type: string, message: string) => void
) {
  const { t } = useTranslation();

  return useMutation({
    mutationFn: (groupId: string) => setAcceptGroup(groupId, dealerId),
    onError: (e) => {
      if (e instanceof AxiosError) sentNotif(NOTIFICATIONS.error, e.message);
    },
    onSuccess: ({ status, message }) => {
      if (status === "error") sentNotif(NOTIFICATIONS.error, message);
      else sentNotif(NOTIFICATIONS.success, message);
    },
  });
}
